import styled, { keyframes } from 'styled-components';
import { Icon } from 'antd';

const TopButton = () => {
  const handleTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return (
    <Div onClick={handleTop}>
      <Icon type="arrow-up" style={{ fontSize: '3rem' }} />
    </Div>
  );
};
const fadeIn = keyframes`
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
`;
const Div = styled.div`
  width: 5rem;
  height: 5rem;
  background-color: #fff;
  border: 1px solid #ddd;
  z-index: 30;
  position: fixed;
  bottom: 8rem;
  right: 2.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: ${fadeIn} 2s linear forwards;
  ${props => props.theme.device.md} {
    bottom: 15rem;
    right: 15rem;
  }
`;
export default TopButton;
